<script>
  import { links } from 'svelte-routing';
  export let mainUrl = 'https://www.fooddisco.co.uk';
</script>

<div>
  <div class="main">
    <div class="header">
      <a href={mainUrl}>
        <div class="fd-logo" />
      </a>
      <div class="links" use:links>
        <a href="{mainUrl}/about">About</a>
        <hr class="bar" />
        <a href="{mainUrl}/residential-developments">Residential</a>
        <hr class="bar" />
        <a href="{mainUrl}/workplaces">Workplaces</a>
        <hr class="bar" />
        <a href="{mainUrl}/food-partners">Food Partners</a>
        <hr class="bar" />
        <a href="/" class="selected">Find My Menu</a>
      </div>
    </div>
  </div>
</div>

<style>
  .main {
    margin: auto;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.09);
  }
  .header {
    max-width: 922px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 17px 15px;
    white-space: nowrap;
  }

  @media only screen and (max-width: 570px) {
    .header {
      padding: 17px 14px;
    }
  }

  .fd-logo {
    width: 235px;
    height: 48px;
    background: url(/logo.svg) center/cover no-repeat;
  }

  @media only screen and (max-width: 570px) {
    .fd-logo {
      transform: scale(0.83);
    }
  }

  .bar {
    width: 21px;
    border: 0;
    border-top: 1px solid rgba(65, 65, 65, 1);
    transform: rotate(-90deg);
    margin: 15px 0;
  }

  .links {
    display: flex;
    align-items: center;
    font-size: 15px;
  }

  .links a {
    margin: 0 10px 0 10px;
  }
  .links a:hover {
    color: #878992;
  }

  .links a.selected {
    color: #eb4624;
  }

  @media only screen and (max-width: 845px) {
    .links {
      display: none;
    }
  }
</style>
